import { PropsWithChildren } from 'react';
import { useToggle } from 'react-use';
import cn from 'classnames';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { Collapse } from '@ui';

type FormBlockExpanderProps = PropsWithChildren<{
  title: string;
}>;

export const FormBlockExpander = ({ title, children }: FormBlockExpanderProps) => {
  const [isOpen, toggleIsOpen] = useToggle(true);

  return (
    <div className="flex flex-col rounded-xl bg-white p-5 shadow-s">
      <button className="flex items-center gap-2" onClick={toggleIsOpen} type="button">
        <div className="flex items-center justify-center size-4 rounded-full bg-[#111]">
          <MdKeyboardArrowDown size={16} className={cn('text-base-90 transition', { '-rotate-90': !isOpen })} />
        </div>
        <h2 className="text-hm text-[#111]">{title}</h2>
      </button>
      <Collapse isExpanded={isOpen} className="flex flex-col gap-5 pt-5">
        {children}
      </Collapse>
    </div>
  );
};
